module.exports = __webpack_public_path__ + "images/application/i-emails-5060ca95.svg";